import {createContext, useCallback, useContext, useEffect, useState} from "react";
import BigNumber from "bignumber.js";
import React from "react";
import useBlock from "../../hooks/useBlock";
import {useWallet} from "use-wallet";
import {Farm} from "../Farms/types";
import {Context as FarmsContext} from "../Farms";
import useSushi from "../../hooks/useSushi";


export const UserAccoutProvider: React.FC<{farms:Farm[],children:any}> = (ev) => {

    const [balance, setBalance] = useState(new BigNumber(0));
    const {blockNumber,unharvested} = useContext(FarmsContext);
    const [allPremium, setAllPremium] = useState(0);
    const [ethAmout, setEthAmout] = useState(new BigNumber(0));

    const farms = ev.farms;
    const {account} = useWallet();
    const sushi = useSushi();

    const fetchBalance = useCallback(async () => {
        const lpContract = farms[0].lpContract;
        let bb = await lpContract.methods.balanceOf(account).call();
        let _ethAmout = await sushi.web3.eth.getBalance(account)

        setBalance(new BigNumber(bb));
        setEthAmout(new BigNumber(_ethAmout));
    }, [account, farms, setBalance,setEthAmout,sushi]);


    const fetchPremium = useCallback(async () => {
        let _tmpAllTsl = 0;
        farms.forEach(({premium}) => {

            _tmpAllTsl += premium;
        });
        setAllPremium(_tmpAllTsl);
    }, [account, farms, setBalance]);

    useEffect(() => {
        if (account && farms[0]) {
            fetchBalance()
        }
        if(unharvested%10 == 0 && unharvested!=0){
            setTimeout( fetchPremium,200)
        }



    }, [account,blockNumber]);

    return <UserAccoutContext.Provider value={
        {
            tokenAmout: balance,
            allPremium,
            ethAmout,

        }
    }>{ev.children}</UserAccoutContext.Provider>
};

export const UserAccoutContext = createContext<{ tokenAmout: BigNumber,allPremium:number,ethAmout:BigNumber }>({
    tokenAmout: undefined,
    ethAmout: undefined,
    allPremium:0,
});
